import { z } from "zod";

export interface RedisPubSubConfig {
	baseUrl: string;
}

export function loadRedisPubSubConfig(): RedisPubSubConfig {
	const env = validateEnvironment();
	return {
		baseUrl: env.REDIS_PUB_SUB_ENDPOINT
	};
}

function validateEnvironment() {
	const envSchema = z.object({
		REDIS_PUB_SUB_ENDPOINT: z.string({
			required_error:
				"REDIS_PUB_SUB_ENDPOINT environment variable is missing"
		})
	});

	const parsed = envSchema.safeParse(process.env);

	if (!parsed.success) {
		throw new Error(parsed.error.errors.map((e) => e.message).join("\n"));
	}

	return parsed.data;
}
